import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { AppSelector } from './AppSelector';
import { buildRedirectUrl } from './modules/landing_plaza/utils/buildRedirectUrl';
import { extractStoreId } from './modules/landing_plaza/utils/extractStoreId';

const pathMatch = window.location.pathname.match(/\/store\/details\/([^/]+)/);
const storeId = pathMatch ? extractStoreId(pathMatch[1]) : null;
const redirectUrl = storeId ? buildRedirectUrl(storeId) : null;

if (redirectUrl) {
  window.location.replace(redirectUrl);
} else {
  ReactDOM.render(<AppSelector />, document.getElementById('root'));
  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  serviceWorker.unregister();
}
